// A dish's sizes as a choice on the dish sheet (Nov 2026). Sizes set up in the back office
// ("Add a size": a 125ml, a bottle, a half) were asked about by a dialog of their own on a
// tap, and the sheet a long press opens didn't know about them at all: House red "as it
// comes" at £7, no measure. Now the sheet shows them as a choose-one "Size", each at what the
// till charges for it, and hands the choice back as the line's `size`, which is how the
// server prices a sized line (routes/orders.py): never as a modifier it would add on top.

export const SIZE_GROUP = '__size';

const pence = (v) => Math.round((Number(v) || 0) * 100);

/** What a size sells for: its own price, or the item's moved by its difference (older rows). */
export const sizePrice = (size, base) => (size?.price != null && size.price !== ''
  ? Number(size.price)
  : (Number(base) || 0) + (Number(size?.price_modifier) || 0));

const sizesOf = (item) => (item?.has_sizes ? (item.size_options || item.sizes || []) : [])
  .filter((s) => s && String(s.name || '').trim());

/** The sheet's "Size" group for a sized item, or null. Prices are differences from the item's
 *  price, as every sheet option's are; the default is the size at the item's own price. */
export function sizeGroupOf(item) {
  const sizes = sizesOf(item);
  if (sizes.length < 2) return null;
  const base = Number(item.price) || 0;
  const at = sizes.findIndex((s) => pence(sizePrice(s, base)) === pence(base));
  return {
    id: SIZE_GROUP, label: 'Size', rule: 'one', print_default: true,
    options: sizes.map((s, i) => ({
      id: `${SIZE_GROUP}:${i}`, name: String(s.name), price: (pence(sizePrice(s, base)) - pence(base)) / 100,
      default: i === (at >= 0 ? at : 0),
    })),
  };
}

/** The size the sheet chose, taken out of its modifiers: `{ size, modifiers }`. */
export function takeSize(modifiers) {
  const size = (modifiers || []).find((m) => String(m?.option_id || '').startsWith(`${SIZE_GROUP}:`));
  return { size: size ? size.name : null, modifiers: (modifiers || []).filter((m) => m !== size) };
}

/** A line's name with its size, as the size dialog always wrote it: "House red (175ml)". */
export const sizedName = (name, size) => (size ? `${name} (${size})` : name);
